import styled, { css } from 'styled-components';
import { WrapperDefault } from '../Shared/Shared';
export const FormChoiceCheckboxWrapper = styled(WrapperDefault)``;

export const ChoiceContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
`;

export const FormChoiceCheckboxButton = styled.div<{
  pressed?: boolean;
  disabled?: boolean;
}>`
  background-color: var(--white);
  cursor: pointer;
  border-radius: 23px;
  border: solid 2px var(--black);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  span {
    font-size: 18px;
    color: var(--text-primary);
    font-weight: bold;
  }
  &:hover {
    background-color: var(--black);
    span {
      color: var(--white);
    }
  }

  height: 48px;
  border-radius: 4px;
  span {
    font-size: 16px;
  }

  ${({ pressed }) =>
    pressed &&
    css`
      background-color: var(--black);
      span {
        color: var(--white);
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      &:hover {
        background-color: var(--white);
        cursor: not-allowed;
        span {
          color: var(--text-primary);
        }
      }
    `}
`;

export const Accessibility = styled.span`
  opacity: 0.6;
  font-size: 12px;
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  right: 24px;
  gap: 5px;
  span {
    font-weight: bold;
  }

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const FormLabel = styled.label`
  height: 45px;
  cursor: pointer;
  flex: 1;
  display: flex;
  input {
    display: none;
    height: 0;
    width: 0;
    &:checked + ${FormChoiceCheckboxButton} {
      + ${Accessibility} {
        color: var(--white);
        span {
          color: var(--white);
        }
      }
      background-color: var(--black);
      span {
        color: var(--white);
      }
    }
  }
`;

export const FormChoiceCheckboxButtons = styled.div<{
  disabled: boolean | undefined;
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
  user-select: none;
  padding: 10px 0;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      input {
        cursor: not-allowed;
        &:hover {
          background-color: var(--white);
        }
      }
    `}
`;
